import React from "react"
import {Bling as GPT} from "react-gpt"
import {GPT_ENDPOINT} from "../../../../config/constants"
import {AdSpacing} from "./components"

interface Cotton22InjectedAdComponentProps {
    injectedAdEnvironment: string
}

export const Cotton22InjectedAdComponent = ({injectedAdEnvironment}: Cotton22InjectedAdComponentProps) => {
    return (
        <AdSpacing>
            <GPT
                adUnitPath={GPT_ENDPOINT}
                slotSize="fluid"
                sizeMapping={[
                    {viewport: [0, 0], slot: [288, 360]},
                    {viewport: [425, 0], slot: [375, 360]},
                    {viewport: [768, 0], slot: [464, 414]},
                ]}
                renderWhenViewable={false}
                targeting={{
                    environment: injectedAdEnvironment,
                    position: "middle",
                }}
            />
        </AdSpacing>
    )
}

export default Cotton22InjectedAdComponent
